import * as go from 'gojs';

export const calculatePinScale = (diagram: go.Diagram) => {
  if (!diagram) {
    return 1;
  }

  return 1 / diagram.scale;
};
